import { acceptHMRUpdate, defineStore } from 'pinia';
import { useAuth } from '@repo/vue/plugins';

export const useAuthStore = defineStore('auth', () => {
  const {
    isLoading,
    isAuthenticated,
    user,
    idTokenClaims,
    error,
    loginWithPopup,
    loginWithRedirect,
    logout,
    getTokenWithPopup,
    getTokenSilently,
    handleCallback,
    checkSession,
    storeUser
  } = useAuth();

  const state = {
    user,
    idTokenClaims,
    isAuthenticated,
    isLoading,
    error
  };
  const actions = {
    loginWithPopup,
    loginWithRedirect,
    logout,
    getTokenSilently,
    getTokenWithPopup,
    handleCallback,
    checkSession,
    storeUser
  };

  return { ...state, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
